<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent1"><a id="ch00_fm05_ded"></a><a id="page_v"></a><em>This book is dedicated to three people</em>.</p>
<p class="noindent1"><em>First, I would like to dedicate it to Bill G. Kremper, a good Marine, a good man, and my beloved grandfather</em>.</p>
<p class="noindent1"><em>I would also like to dedicate it to my father, Joseph R. Hughes, who would have been so proud of me for writing this book if cancer had not taken him from us. I miss you, dad</em>.</p>
<p class="noindent1"><em>Lastly, I dedicate it to my amazing son, Gabriel Martin Hughes, who has his great-grandfather’s cheerful disposition, his grandfather’s inquisitiveness, and his father’s unconditional love</em>.<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_ded.vue?4dcdeed5